import StatsSection from './StatsSection';

export default StatsSection;
